import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9912576"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-recommend-form__field js-form-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "語学-その他言語"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "職")
], -1))
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = {
  class: "p-recommend-form__list-2 js-entry-list",
  "data-entries": "3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-form__heading-1" }, "言語", -1))
const _hoisted_6 = { class: "p-recommend-form__group-1" }
const _hoisted_7 = { class: "p-recommend-form__group-1-block-1 --no-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "言語レベル", -1))
const _hoisted_9 = { class: "-is-select-wrap" }
const _hoisted_10 = ["onClick", "disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "言語", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "を削除する", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "その他言語を追加する", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "p-recommend-form__field" }
const _hoisted_18 = { class: "p-recommend-form__group-1-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-1" }, "語学について補足", -1))

import { ref, watch } from 'vue';
import ResumeSelect from '../../components/ResumeSelect.vue';
import { QualificationLanguageDetail } from '@/types';
import ValidatableField from '@/components/ValidatableField.vue';
import InvalidMessage from '@/components/InvalidMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QualOtherLanguage',
  props: {
    qualLangDetail: null
  },
  setup(__props: any) {

const props = __props as {
  qualLangDetail?: QualificationLanguageDetail;
}

const MAX_OTHER_LANG = 3;

const otherLangs = ref([
  {
    id: 1,
    isShow: true,
    skillId: '',
    levelId: '',
  },
  {
    id: 2,
    isShow: false,
    skillId: '',
    levelId: '',
  },
  {
    id: 3,
    isShow: false,
    skillId: '',
    levelId: '',
  }
]);



function addSkill() {
  const hidden = otherLangs.value.filter(l => !l.isShow)[0];
  hidden.isShow = true;
}
function removeSkill(idx: number) {
  otherLangs.value[idx].isShow = false;
  for (let i = idx; i < 3; i++) {
    if (otherLangs.value[i + 1]) {
      otherLangs.value[i] = {...otherLangs.value[i+1], id: otherLangs.value[i].id};
    }
  }
  otherLangs.value[2] = {
    id: 3,
    isShow: false,
    levelId: '',
    skillId: '',
  };
}

const toEmpty = (v: number) => v ? String(v) : '';

watch(() => props.qualLangDetail, (newVal) => {
  if (newVal) {
    otherLangs.value[0].skillId = toEmpty(newVal.otrLang1Id);
    otherLangs.value[0].levelId = toEmpty(newVal.otrLang1LevelId);

    otherLangs.value[2].skillId = toEmpty(newVal.otrLang3Id);
    otherLangs.value[2].levelId = toEmpty(newVal.otrLang3LevelId);
    if (newVal.otrLang3Id || newVal.otrLang3LevelId) {
      otherLangs.value[2].isShow = true;
    }

    otherLangs.value[1].skillId = toEmpty(newVal.otrLang2Id);
    otherLangs.value[1].levelId = toEmpty(newVal.otrLang2LevelId);
    if (newVal.otrLang2Id || newVal.otrLang2LevelId || otherLangs.value[2].isShow) {
      otherLangs.value[1].isShow = true;
    }
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InvalidMessage, { name: "qualLangDetail.engMemo" })
      ]),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherLangs.value, (skill, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: skill.id,
            class: "js-entry-item"
          }, [
            (skill.isShow)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(ResumeSelect, {
                      "model-value": otherLangs.value[i].skillId,
                      "onUpdate:model-value": ($event: any) => ((otherLangs.value[i].skillId) = $event),
                      name: `qualLangDetail.otrLang${i + 1}Id`,
                      label: "言語",
                      id: "otherLang",
                      className: "p-recommend-form__select"
                    }, null, 8, ["model-value", "onUpdate:model-value", "name"]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(ResumeSelect, {
                          "model-value": otherLangs.value[i].levelId,
                          "onUpdate:model-value": ($event: any) => ((otherLangs.value[i].levelId) = $event),
                          name: `qualLangDetail.otrLang${i + 1}LevelId`,
                          label: "言語レベル",
                          id: "languageLevel",
                          className: "p-recommend-form__select"
                        }, null, 8, ["model-value", "onUpdate:model-value", "name"])
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "p-recommend-form__delete-2",
                    type: "button",
                    onClick: ($event: any) => (removeSkill(i)),
                    disabled: otherLangs.value.filter(l => l.isShow).length <= 1
                  }, _hoisted_13, 8, _hoisted_10)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "p-recommend-form__add --mt-3",
        type: "button",
        disabled: otherLangs.value.filter(l => l.isShow).length >= MAX_OTHER_LANG,
        onClick: addSkill
      }, _hoisted_16, 8, _hoisted_14)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode(ValidatableField, {
          as: "textarea",
          name: "qualLangDetail.engMemo",
          rules: "max:1000",
          maxlength: "1000",
          label: "語学について補足",
          class: "p-recommend-form__textarea",
          id: "form-qualification-message-2",
          placeholder: "入力してください"
        })
      ])
    ])
  ], 64))
}
}

})